export default {
    accept: 'Aceptar'
}